import React, {Component} from 'react';
import {injectIntl, IntlProvider} from 'react-intl';

import Config from '../utils/Configuration';

export default function decorateContainer(component, defaultI18nLabels) {
    const IntlWrappedComponent = injectIntl(component, {
        withRef: true
    });

    const DecoratedContainer = class extends Component {
        geti18nLabels(i18nLabels) {
            const i18Array = Object.entries(i18nLabels);
            return i18Array.reduce((map, i18Label) => {
                map[i18Label[0]] = {
                    id: i18Label[0],
                    defaultMessage: i18Label[1]
                };
                return map;
            }, {});
        }

        calculateIntlProps() {
            let {i18nLabels, localeLanguage} = this.props;
            if (!i18nLabels && defaultI18nLabels) {
                i18nLabels = defaultI18nLabels;
            }
            const language = localeLanguage || sessionStorage.getItem(Config.localeLanguageKey) || 'en';
            const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
            const {locale = language} = this.props;

            const props = {locale};
            if (typeof i18nLabels !== 'undefined') {
                const translatedI18nLabels =
                    i18nLabels[languageWithoutRegionCode] || i18nLabels[language] || i18nLabels.en;
                props.i18nLabels = this.geti18nLabels(translatedI18nLabels);
                props.messages = translatedI18nLabels;
            }
            return props;
        }

        render() {
            const intlProps = this.calculateIntlProps();
            const wrapperProps = {...this.props, ...intlProps};
            return (
                <IntlProvider {...intlProps}>
                    <IntlWrappedComponent
                        innerRef={(str) => {
                            this.wrappedInstance = str;
                        }}
                        {...wrapperProps}
                    />
                </IntlProvider>
            );
        }
    };

    DecoratedContainer.Component = component;
    return DecoratedContainer;
}
